import { render, staticRenderFns } from "./RubricPresetPreview.vue?vue&type=template&id=622f25e0&scoped=true"
import script from "./RubricPresetPreview.vue?vue&type=script&lang=js"
export * from "./RubricPresetPreview.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=622f25e0&prod&scoped=true&lang=css&external"
import style1 from "./RubricPresetPreview.vue?vue&type=style&index=1&id=622f25e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f25e0",
  null
  
)

export default component.exports